import axios from "../axios";

// Public endpoints behind the link in an invitation email (no login required)

export async function getInvitation(token) {
	return axios
		.get(`/invitation/${token}.json`)
		.then((res) => ({ ok: true, data: res.data }))
		.catch((err) => ({ ok: false, status: err.response?.status }));
}

export async function acceptInvitation(token, password) {
	return axios
		.post(`/invitation/${token}.json`, JSON.stringify({ password }), { headers: { "Content-Type": "application/json" } })
		.then(() => ({ ok: true }))
		.catch((err) => ({ ok: false, status: err.response?.status, data: err.response?.data }));
}
